
/**
 * 강의 콘텐츠 유형
 */
export type GetCourseDetail200SectionsItemLecturesItemContentType = typeof GetCourseDetail200SectionsItemLecturesItemContentType[keyof typeof GetCourseDetail200SectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCourseDetail200SectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  VIDEO_MARKDOWN: 'VIDEO_MARKDOWN',
  QUIZ: 'QUIZ',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  TEXT: 'TEXT',
  ASSIGNMENT: 'ASSIGNMENT',
  LIVE: 'LIVE',
  DISCUSSION: 'DISCUSSION',
  ARTICLE: 'ARTICLE',
  UNKNOWN: 'UNKNOWN',
} as const;
